var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-async-item mb-4"},[(_vm.loading)?_c('ghost-loader',{attrs:{"height":_vm.height,"width":_vm.width,"inline":_vm.inline}}):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }